import React from 'react'
import NavBar from '../Component/NavBarFooter/NavBar'
import Banner from '../Component/BlogSingle/Banner'
import BlogDetailSection from '../Component/BlogSingle/BlogDetailSection'
import Footer from '../Component/NavBarFooter/Footer'
import blogData from '../Data/blogData.json'
import { useParams } from 'react-router-dom'
function BlogSingle() {
  const parmas=window?.location?.pathname
  const blog=blogData?.find((item)=>'/'+item?.title
    ?.toLowerCase()?.replace(/[^a-z0-9\s]/g, "")?.trim()?.replace(/\s+/g, "-")===parmas   
)
  return (
    <div>
        <NavBar/>
        <Banner blog={blog}/>
        <BlogDetailSection blog={blog}/>
        <Footer/>
    </div>
  )
}

export default BlogSingle